import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { DialogContainer } from 'common/components';

import * as actions from './actions';
import TemplateForm from './components/TemplateForm';
import * as selectors from './selectors';

const Container = ({
    closeModal,
    fetchSystemTypes,
    isNewRecord,
    isOpenModal,
    reset,
    systemTypes,
}) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (isOpenModal) fetchSystemTypes();
    }, [isOpenModal]);

    useEffect(() => {
        return () => {
            reset();
        };
    }, []);

    return (
        <DialogContainer
            onClose={() => closeModal()}
            open={isOpenModal}
            fullWidth={true}
            title={`${isNewRecord ? t('Create') : t('Update')} ${t(
                'Template',
            ).toLowerCase()}`}
        >
            <TemplateForm
                closeModal={closeModal}
                isNewRecord={isNewRecord}
                systemTypes={systemTypes}
            />
        </DialogContainer>
    );
};

Container.propTypes = {
    closeModal: PropTypes.func,
    fetchSystemTypes: PropTypes.func,
    isNewRecord: PropTypes.bool,
    isOpenModal: PropTypes.bool,
    reset: PropTypes.func,
    systemTypes: PropTypes.array,
};

const mapStateToProps = createStructuredSelector({
    isNewRecord: selectors.getIsNewRecord,
    isOpenModal: selectors.getIsOpenModal,
    systemTypes: selectors.getSystemTypesData,
});

const mapDispatchToProps = (dispatch) => ({
    closeModal: () => dispatch(actions.closeModal()),
    fetchSystemTypes: () => dispatch(actions.fetchSystemTypes()),
    reset: () => dispatch(actions.reset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Container);
